<template>
  <div class="stepper">
    <ul class="stepper-steps grid" :class="'cols-' + steps.length">
      <li
        class="stepper-item"
        :class="'stepper-' + steps.length + (step === index ? ' active' : '')"
        v-for="(value, index) in steps"
        :key="value.number">
        <span class="stepper-step">{{ index + 1 }}</span>
        <label class="stepper-label">{{ value.label }}</label>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    step: {
      type: Number,
      default: -1
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';

.stepper {
  box-sizing: border-box;
  margin-bottom: 20px;

  .stepper-steps {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .stepper-item {
    text-align: center;
    position: relative;

    &.active {
      .stepper-step {
        background-color: $primary;
      }
    }

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 1px;
      background-color: $primary;
    }

    &.stepper-3, &.stepper-4, &.stepper-5, &.stepper-6 {
      &:before {
        width: calc(100% - 55px);
        transform: translate(calc(50% + 60px), 21px);
      }
    }

    &:last-child {
      &:before {
        display: none;
      }
    }
  }

  .stepper-step {
    background-color: lighten($primary, 40%);
    width: 38px;
    height: 38px;
    display: inline-block;
    border-radius: 50%;
    color: white;
    line-height: 30px;
    font-size: 1.6rem;
    text-align: center;
  }

  .stepper-label {
    display: block;
    font-size: 0.7rem;
    margin-top: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/util/Stepper.vue